import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojaisalmertour() {



  const cardData =
  {
    keyword: 'Pune to Jaisalmer Tour Package',
    heading: 'Sanavi Travels: Pune to Jaisalmer Tour Package',
    headingDescription: 'Sanavi Travels offers Pune to Jaisalmer Tour Package, providing safe, comfortable, and well-organized transportation for families, groups, and sightseeing travelers exploring the Golden City of Jaisalmer. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a hassle-free journey. With experienced drivers, customized tour itineraries, transparent pricing, and 24/7 booking support, the Pune to Jaisalmer tour package guarantees punctual, reliable, and stress-free travel. Choose Sanavi Travels for a trusted Pune to Jaisalmer bus tour, delivering comfort, safety, and convenience for a memorable desert travel experience.',

    top: 'Top Places to Visit in Jaisalmer with Sanavi Travels',


"topPlaces": [
  {
    "title": "Girnar Hill",
    "description": "Girnar Hill, located near Junagadh in Gujarat, is one of India’s most revered pilgrimage destinations and a prominent center for both Hinduism and Jainism. Rising to a height of about 1,100 meters, the hill features hundreds of stone steps that devotees climb as an act of devotion. The trek passes through lush landscapes, ancient temples, and sacred shrines, offering a combination of spirituality, adventure, and natural beauty."
  },
  {
    "title": "Ambika Devi Temple",
    "description": "Situated at the base of Girnar Hill, Ambika Devi Temple is a sacred shrine dedicated to Goddess Ambika. The temple attracts thousands of pilgrims who come to seek blessings for prosperity, health, and spiritual growth. Its architecture, rituals, and serene surroundings make it an important starting point for the Girnar pilgrimage."
  },
  {
    "title": "Dattatreya Temple",
    "description": "Located midway up Girnar Hill, the Dattatreya Temple is dedicated to Lord Dattatreya, an incarnation embodying the trinity of Brahma, Vishnu, and Shiva. Devotees often stop here during the climb to rest and offer prayers. The temple provides panoramic views of the surrounding landscape and the city of Junagadh."
  },
  {
    "title": "Jain Temples on Girnar",
    "description": "Girnar Hill hosts a complex of ancient Jain temples, some dating back over 1,000 years. These temples are dedicated to various Tirthankaras and are known for their intricate carvings, marble architecture, and spiritual sanctity. The Neminath Temple, in particular, is a major highlight for Jain pilgrims and visitors interested in history and architecture."
  },
  {
    "title": "Girnar Ropeway (Modern Access)",
    "description": "To assist pilgrims and tourists, a ropeway has been constructed, offering a convenient and scenic ascent to some of the hill’s key temples. The ropeway provides breathtaking views of the hills, forests, and Junagadh city, making the pilgrimage accessible to all."
  },
  {
    "title": "Junagadh Panorama",
    "description": "From various points along Girnar Hill, especially near the summit, visitors can enjoy panoramic views of Junagadh city, surrounding plains, and the distant Gir forests. These vistas are particularly stunning during sunrise and sunset, adding a visual spectacle to the spiritual journey."
  },
  {
    "title": "Girnar Wildlife and Nature Trails",
    "description": "Girnar is surrounded by rich biodiversity, including forests, birds, and small wildlife. Nature enthusiasts and trekkers enjoy exploring the trails, spotting endemic species, and appreciating the serene natural environment along with the religious significance."
  },
  {
    "title": "Neminath Jain Temple",
    "description": "Neminath Temple, located near the summit of Girnar, is dedicated to Lord Neminath, the 22nd Tirthankara. This temple is a key pilgrimage site for Jains, featuring elaborate marble work, intricate sculptures, and a spiritually charged ambiance that draws devotees from across India."
  },
  {
    "title": "Cultural and Religious Significance",
    "description": "Girnar Hill holds immense religious importance for both Hindus and Jains. It represents centuries of devotion, architectural brilliance, and spiritual tradition. The pilgrimage, whether by climbing steps or taking the ropeway, is considered highly meritorious and spiritually uplifting."
  },
  {
    "title": "Festivals and Pilgrimage Events",
    "description": "Girnar hosts annual religious festivals such as the Girnar Parikrama and other temple celebrations. Devotees participate in rituals, processions, and ceremonial offerings, making these events spiritually enriching and culturally immersive. These festivals attract thousands of pilgrims and tourists alike."
  }
]
,



"services": [
{
"name": "Pune to Jaisalmer Tour Package",
"description": "Pune to Jaisalmer Tour Package offers a complete travel solution for exploring the golden city of Jaisalmer and its majestic forts, havelis, and desert landscapes. Perfect for families, groups, and adventure enthusiasts, this package combines comfortable bus travel with well-planned itineraries, sightseeing stops, and hassle-free travel arrangements for an unforgettable Rajasthan experience."
},
{
"name": "Jaisalmer Bus Hire from Pune",
"description": "Jaisalmer Bus Hire from Pune provides convenient and reliable bus rental services for long-distance travel to Rajasthan. Designed for tourists, families, and group travelers, these buses offer spacious seating, experienced drivers, and smooth highway travel, ensuring a comfortable journey from Pune to Jaisalmer."
},
{
"name": "AC Bus Pune to Jaisalmer",
"description": "AC Bus Pune to Jaisalmer ensures a cool and comfortable ride during the long desert journey. Equipped with air-conditioning, ergonomic seats, and modern interiors, these buses are ideal for family trips, group tours, and long-distance travel in comfort."
},
{
"name": "Luxury Rajasthan Tour Bus",
"description": "Luxury Rajasthan Tour Bus provides premium travel experiences for those seeking comfort and elegance. With luxurious seating, ample legroom, modern amenities, and skilled drivers, this service makes the journey from Pune to Jaisalmer smooth, safe, and relaxing."
},
{
"name": "Desert Safari Bus Package",
"description": "Desert Safari Bus Package combines travel to Jaisalmer with organized desert excursions and sightseeing. Ideal for adventure seekers and families, this package includes comfortable bus travel, expert drivers, and planned stops for exploring dunes, forts, and cultural attractions."
},
{
"name": "Family Jaisalmer Trip",
"description": "Family Jaisalmer Trip bus services are tailored for family-friendly travel, ensuring safety, comfort, and convenience. Spacious seating, smooth rides, and experienced drivers make long-distance travel enjoyable for all age groups."
},
{
"name": "Group Travel Jaisalmer Bus",
"description": "Group Travel Jaisalmer Bus provides efficient transportation for large groups, clubs, and tour operators. High-capacity buses, organized schedules, and professional drivers ensure a seamless journey for group travelers heading to Jaisalmer."
},
{
"name": "Affordable Jaisalmer Tour Package",
"description": "Affordable Jaisalmer Tour Package offers budget-friendly bus travel solutions without compromising comfort or safety. Perfect for students, families, and group travelers seeking economical options for a long-distance Rajasthan trip."
},
{
"name": "Chauffeur Driven Tour Bus",
"description": "Chauffeur Driven Tour Bus ensures a stress-free and safe journey with skilled drivers handling long-distance routes and desert highways. Passengers can relax and enjoy the scenic Rajasthan landscapes during their Pune to Jaisalmer tour."
},
{
"name": "Best Jaisalmer Package Pune",
"description": "Best Jaisalmer Package Pune is known for high-quality buses, reliable service, and customer satisfaction. Suitable for family tours, group travel, and luxury trips, it ensures timely departures, comfortable buses, and well-planned itineraries."
},
{
"name": "Pune Jaisalmer Travel Bus",
"description": "Pune Jaisalmer Travel Bus offers organized and dependable bus services for tourists traveling to Jaisalmer. With comfortable seating, professional drivers, and safe long-distance travel, this service makes planning and executing the trip easy and hassle-free."
},
{
"name": "Tourist Bus Rajasthan",
"description": "Tourist Bus Rajasthan caters to travelers exploring Jaisalmer and nearby Rajasthan attractions. Flexible itineraries, modern buses, and professional chauffeurs make sightseeing convenient and enjoyable for tourists and travel groups."
},
{
"name": "Long Distance Bus Tour",
"description": "Long Distance Bus Tour service ensures safe and comfortable bus travel for multi-day journeys from Pune to Jaisalmer. With well-maintained buses, experienced drivers, and planned rest stops, passengers can enjoy a smooth and enjoyable long-distance trip."
},
{
"name": "Online Bus Booking Pune",
"description": "Online Bus Booking Pune provides a convenient platform to reserve buses for Jaisalmer trips. Travelers can choose from various bus types, select schedules, and confirm bookings quickly, ensuring a hassle-free travel experience."
},
{
"name": "Rajasthan Holiday Bus",
"description": "Rajasthan Holiday Bus offers specialized bus travel for holiday trips to Jaisalmer and other destinations in Rajasthan. With comfortable buses, professional chauffeurs, and planned itineraries, it ensures a memorable and scenic travel experience."
}
],
"tableData": [
["Pune to Jaisalmer Tour Package", "Jaisalmer Bus Hire from Pune"],
["AC Bus Pune to Jaisalmer", "Luxury Rajasthan Tour Bus"],
["Desert Safari Bus Package", "Family Jaisalmer Trip"],
["Group Travel Jaisalmer Bus", "Affordable Jaisalmer Tour Package"],
["Chauffeur Driven Tour Bus", "Best Jaisalmer Package Pune"],
["Pune Jaisalmer Travel Bus", "Tourist Bus Rajasthan"],
["Long Distance Bus Tour", "Online Bus Booking Pune"],
["Rajasthan Holiday Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Jaisalmer Tour Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers an organized and comfortable Pune to Jaisalmer bus tour package, perfect for group tours, family trips, and long-distance sightseeing adventures."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly maintained, ensuring a smooth and enjoyable journey for your Pune to Jaisalmer tour."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our professional and licensed drivers are experienced in multi-state long-distance travel, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear pricing for Pune to Jaisalmer tour packages, including fuel, tolls, driver allowance, and taxes — with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, itinerary planning, and on-trip assistance for your tour."
  },
  {
    "WhyChooseheading": "Customizable Tour Itineraries",
    "WhyChoosedescription": "We provide flexible tour plans allowing you to include sightseeing, desert safaris, and stops according to your preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual departures and dependable service, making Sanavi Travels a trusted choice for Pune to Jaisalmer tours."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Jaisalmer tour packages?',
    answer: 'Yes, Sanavi Travels provides complete bus tour packages from Pune to Jaisalmer for group travel, sightseeing, and long-distance trips.'
  },
  {
    question: 'How can I book a Pune to Jaisalmer tour?',
    answer: 'You can book the tour package via our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for this tour?',
    answer: 'We offer mini buses, 20-seater, 32-seater, 45-seater, and 50-seater buses depending on your group size.'
  },
  {
    question: 'Can the itinerary be customized?',
    answer: 'Yes, the Pune to Jaisalmer tour itinerary can be tailored to include sightseeing spots, desert safaris, and rest stops.'
  },
  {
    question: 'Are the drivers experienced with long-distance multi-state travel?',
    answer: 'Absolutely. Our drivers are licensed and experienced in long-distance and multi-state routes.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Jaisalmer tour.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized for a safe and hygienic journey.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is this tour suitable for families and large groups?',
    answer: 'Yes, the Pune to Jaisalmer bus tour package is ideal for families, senior citizens, and group travelers.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Mehra',
    feedback: 'Our Pune to Jaisalmer tour with Sanavi Travels was amazing! Comfortable bus, professional driver, and smooth journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Rathi',
    feedback: 'Sanavi Travels made our long-distance tour comfortable and well-organized. Highly recommend their service!',
    rating: 5
  }
];



















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Jaisalmer Tour Package - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Jaisalmer tour packages with AC and luxury buses. Perfect for desert safari trips, family vacations, group travel, and long-distance Rajasthan tours. Affordable, chauffeur-driven buses with online booking available.",
  "touristType": "Family Trip, Group Travel, Desert Safari, Long Distance Travel, Rajasthan Tourism",
  "departureLocation": "Pune",
  "arrivalLocation": "Jaisalmer, Rajasthan",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "18"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Pune to Jaisalmer Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Jaisalmer tour packages by Sanavi Travels. AC and luxury buses for desert safari trips, family vacations, group travel, and long-distance Rajasthan tours. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/201.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetojaisalmertour;